(function () {
    'use strict';

    angular
        .module('adm')
        .config(AdmJobDescriptionRoute);

    AdmJobDescriptionRoute.$inject = ['$stateProvider'];

    /* @ngInject */
    function AdmJobDescriptionRoute ($stateProvider) {
        $stateProvider
            .state('root.adm.jobDescription', {
                abstract: true,
                url: '/jobDescription',
                resolve: {
                    /* Inserir as regras de Acl aqui! */
                }
            })
            .state('root.adm.jobDescription.list', {
                url:'/list',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/adm/jobDescription/list/list.html',
                        controller: 'AdmJobDescriptionListController',
                        controllerAs: 'admJobDescriptionList'
                    }
                }
            })
            .state('root.adm.jobDescription.create', {
                url:'/create',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/adm/jobDescription/create/form.html',
                        controller: 'AdmJobDescriptionCreateController',
                        controllerAs: 'admJobDescriptionCreate'
                    }
                }
            });
    }
})();